import {
  systemUiMessage,
  USER_ANSWERED_VEHICLE_USAGE,
  USER_ANSWERED_HAD_ACCIDENT,
  USER_ANSWERED_NIGHT_PARKING,
  USER_ANSWERED_VIOLATIONS,
  USER_ANSWERED_TRACKING_DEVICE,
  USER_ANSWERED_VEHICLE_FINANCING,
  USER_ANSWERED_NUMBER_OF_DRIVERS,
} from "../../constants/ameenSignals";
import {
  saveVehicleUsage,
  saveHadAccidentLastYear,
  saveNightParkingLocation,
  saveTotalViolationsLastYear,
  saveHasTrackingDevice,
  saveVehicleFinancing,
  saveNumberOfDrivers,
} from "../../services/underwritingQuestionService";
import { FlowStep } from "../../agents/types";

export interface UnderwritingHandlers {
  onVehicleUsageSelect: (vehicleUsageId: number) => Promise<void>;
  onHadAccidentSelect: (value: boolean) => Promise<void>;
  onNightParkingSelect: (nightParkingLocationId: number) => Promise<void>;
  onViolationsSubmit: (value: number) => Promise<void>;
  onTrackingDeviceSelect: (value: boolean) => Promise<void>;
  onVehicleFinancingSelect: (vehicleFinancingId: number) => Promise<void>;
  onNumberOfDriversSubmit: (value: number) => Promise<void>;
}

export function createHandleUnderwritingAnswer(
  send: (msg: { text: string }, interrupt?: boolean) => void,
  setFlowStep: (step: FlowStep) => void,
  showLoading?: (message: string, type?: "api" | "document_upload" | "vehicle_analyze") => void,
  hideLoading?: () => void
): UnderwritingHandlers {
  const runWithLoading = async <T>(
    event: string,
    payload: string,
    fn: () => Promise<T>
  ) => {
    showLoading?.("جاري حفظ الإجابة...", "api");
    try {
      await fn();
      send({ text: systemUiMessage(event, payload) }, true);
    } catch (error) {
      console.error("[Underwriting] API error:", error);
      const errMsg = error instanceof Error ? error.message : String(error);
      send(
        {
          text: systemUiMessage(event, `"error: ${errMsg}". Tell the user the save failed and ask them to try again.`,
          ),
        },
        true
      );
    } finally {
      hideLoading?.();
      setFlowStep("idle");
    }
  };

  return {
    onVehicleUsageSelect: (vehicleUsageId: number) =>
      runWithLoading(USER_ANSWERED_VEHICLE_USAGE, String(vehicleUsageId), () =>
        saveVehicleUsage(vehicleUsageId)
      ),

    onHadAccidentSelect: (value: boolean) =>
      runWithLoading(USER_ANSWERED_HAD_ACCIDENT, String(value), () =>
        saveHadAccidentLastYear(value)
      ),

    onNightParkingSelect: (nightParkingLocationId: number) =>
      runWithLoading(USER_ANSWERED_NIGHT_PARKING, String(nightParkingLocationId), () =>
        saveNightParkingLocation(nightParkingLocationId)
      ),

    onViolationsSubmit: (value: number) =>
      runWithLoading(USER_ANSWERED_VIOLATIONS, String(value), () =>
        saveTotalViolationsLastYear(value)
      ),

    onTrackingDeviceSelect: (value: boolean) =>
      runWithLoading(USER_ANSWERED_TRACKING_DEVICE, String(value), () =>
        saveHasTrackingDevice(value)
      ),

    onVehicleFinancingSelect: (vehicleFinancingId: number) =>
      runWithLoading(USER_ANSWERED_VEHICLE_FINANCING, String(vehicleFinancingId), () =>
        saveVehicleFinancing(vehicleFinancingId)
      ),

    onNumberOfDriversSubmit: (value: number) =>
      runWithLoading(USER_ANSWERED_NUMBER_OF_DRIVERS, String(value), () =>
        saveNumberOfDrivers(value)
      ),
  };
}
